<template><div><h1 id="eloqua-e-mailversand-zuordnung" tabindex="-1"><a class="header-anchor" href="#eloqua-e-mailversand-zuordnung"><span>Eloqua E-Mailversand Zuordnung</span></a></h1>
<p>Eloqua E-Mailversand Zuordnung — Zuordnung für E-Mailversand</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle wird die Zuordnung der versendeten E-Mails zwischen Eloqua und funtrade definiert. Bei dieser Zuordnung handelt es sich um Eloqua AssetId für den entsprechenden E-Mailversand sowie E-Mail Bounces welcher in funtrade zu einem Ereignis zugeordnet wird.</p>
<p>Pfad: <code v-pre>Datenaustausch → Tabellen → Eloqua → Eloqua E-Mailversand Zuordnung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Feldwert</dt>
<dd>In Eloqua definierter Wert (AssetId)</dd>
<dt>Ereignis</dt>
<dd>Ereignis</dd>
<dt>Position</dt>
<dd>Ereignisposition</dd>
<dt>Ereignisbezeichnung</dt>
<dd>Ereignisbezeichnung (read-only)</dd>
<dt>Ereignisstatus</dt>
<dd>Ereignisstatus (Initial, fix vorgegeben)</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/eloqua.html" title="3. Eloqua (Marketing Automation)">Eloqua</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.EloquaEreigniswahlNachText.html" title="Eloqua Ereigniswahl nach Text">Ereigniswahl nach Text</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.EloquaBouncesEreignis.html" title="Eloqua Ereignis für Bounces">Bounces-Ereignis</RouteLink></p>
</div></template>


